import React from 'react';

import { ReactComponent as HomeIcon } from '../../asset/HomeIcon.svg';
import classNames from './EABDHomeIconButton.module.scss';

export interface HomeIconButtonProps
  extends Readonly<{
    onPress: () => void;
  }> {}

export const HomeIconButton = React.memo<HomeIconButtonProps>((props) => {
  const { onPress } = props;

  return (
    <button onClick={onPress} type={'button'} className={classNames.button}>
      <HomeIcon className={classNames.icon} />
    </button>
  );
});
